import React from 'react'

// components
import RegistrationStep from 'components/register/shared/RegistrationStep'
import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'

// containers
import Form from 'components/account/EmergencyContacts/Form'
import Container from '@mui/material/Container'

const NewEmergencyContact = props => {
  const { mutationLoading, form } = props

  const buttonText = mutationLoading ? 'Creating...' : 'Create'

  return (
    <RegistrationStep>
      <Typography gutterBottom variant='h2' align='center'>
        Add an Emergency Contact
      </Typography>
      <Typography pb={4} variant='h3' align='center'>
        (other than parents/guardians)
      </Typography>
      <Container>
        <Typography paragraph fontWeight='fontWeightMedium'>
          NOTE: Emergency contacts will have the ability to pick up the camper
          at any time. Please do not list any person who should not be able to
          leave with the child outside of emergency situations.
        </Typography>
      </Container>
      {!form ? <Loading /> : <Form buttonText={buttonText} {...props} />}
    </RegistrationStep>
  )
}

export default NewEmergencyContact
